import React, { useEffect, useState, useRef } from "react";
import {
  Table,
  Input,
  Row,
  Col,
  Select,
  Typography,
  Divider,
  Button,
  Spin,
  message,
  Card,
  Image,
  Menu,
  Popover,
} from "../../../components/common/utils/antd-imports/AntdImports.js";
import { useMediaQuery } from "react-responsive";
import "./Payments.css";
import { useDispatch, useSelector } from "react-redux";
import {
  downloadInvoice,
  getBuyerPaymentsList,
} from "../../../store/thunks/buyer-thunks/BuyerThunks";
import {
  formatDate,
  formatToUSCurrency,
  handleCopy,
} from "../../../components/common/utils/Utils.js";
import DownloadDocumentIcon from "../../../components/common/reusable-svg-icons/download-document-icon.js";
import Arrow3 from "../../../assests/Arrow 3.svg";
import { ReactComponent as SearchIcon } from "../../../assests/search-icon.svg";
import "../../../../src/main.css";
import {
  CopyOutlined,
  EllipsisOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
import ShareIcon from "../../../components/common/reusable-svg-icons/share-icon.js";
import { downloadQuote } from "../../../store/thunks/common-thunks/commonThunk.js";
import ShareCampaign from "../../../components/modal/share-campaign-modal/ShareCampaign.js";
import { useNavigate } from "react-router-dom";
import EmptyViewCard from "../../../components/common/empty-view-card/EmptyViewCard";
import { addBreadcrumb } from "../../../store/slices/common-slice/bread-crumbs/BreadCrumbSlice.js";
import BreadcrumbNav from "../../../components/common/bread-crumbs/BreadCrumb.js";

const Payments = ({ isDashboard }) => {
  const isMobile = useMediaQuery({ maxWidth: "769px" });
  const navigate = useNavigate();
  const [searchPayments, setSearchPayments] = useState("");
  const { Text } = Typography;
  const [currentPage, setCurrentPage] = useState(1);
  const [campaignId, setCampaignId] = useState(null);
  const [campaignCid, setCampaignCid] = useState(null);
  const [hoveredItem, setHoveredItem] = useState(false);
  const dispatch = useDispatch();
  const { isPaymentsLoading, buyerPaymentsList, downloadInvoicePdf } =
    useSelector((state) => state.buyerPayments);
  const { quotePdf } = useSelector((state) => state.sellerCampaigns);
  const [filteredList, setFilteredList] = useState(
    buyerPaymentsList ? buyerPaymentsList : []
  );
  const [type, setType] = useState(false);
  const [shareCampaign, setShareCampaign] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);
  const [recordId, setRecordId] = useState(false);
  const goToSubPage = (record) => {
    dispatch(
      addBreadcrumb([
        {
          title: "Campaigns",
          path: `/buyer/mycampaigns?segment=insertion_order`,
        },
        { title: record?.name, path: record?.campaign_id },
      ])
    );
  };
  const goToSubPage1 = ({ title, path }) => {
    dispatch(addBreadcrumb({ title, path }));
  };
  const content = (payment) => {
    return (
      <div className="payment-action-items">
        <Menu>
          <Menu.Item
            key="invoice"
            onMouseEnter={() => setHoveredItem("invoice")}
            onMouseLeave={() => setHoveredItem(null)}
            onClick={() => downloadQuoteInvoice(payment, "invoice")}
          >
            <span className="action-items-text">
              <DownloadDocumentIcon
                color={"#000"}
                isHovered={hoveredItem === "invoice"}
                hoveredColor={"#fff"}
                className="action-icons"
              />
              Download Invoice
            </span>
          </Menu.Item>
          <Menu.Item
            key="quote"
            onClick={() => downloadQuoteInvoice(payment, "quote")}
            onMouseEnter={() => setHoveredItem("quote")}
            onMouseLeave={() => setHoveredItem(null)}
          >
            <span className="action-items-text">
              <FileTextOutlined
                className="action-icons quote-icon"
                style={{ color: hoveredItem === "quote" ? "#fff" : "#000" }}
              />
              Download Quote
            </span>
          </Menu.Item>
          <Menu.Item
            key="share"
            onClick={() => handleShareCampaign(payment)}
            onMouseEnter={() => setHoveredItem("share")}
            onMouseLeave={() => setHoveredItem(null)}
          >
            <span className="action-items-text">
              <ShareIcon
                className="action-icons"
                isHovered={hoveredItem === "share"}
                hoveredColor={"#fff"}
                color={"#000"}
              />
              Share Campaign
            </span>
          </Menu.Item>
        </Menu>
      </div>
    );
  };

  const searchDidMountRef = useRef(false);
  const handleOpenMenu = (record) => {
    setRecordId(record.id);
    setOpenMenu(!openMenu);
  };
  const getPendingFee = (record) => {
    return formatToUSCurrency(
      (
        (record?.act_budget + record?.processing_fee)?.toFixed(2) - record?.paid
      )?.toFixed(2)
    );
  };
  const handleShareCampaign = (record) => {
    setCampaignId(record.id);
    setShareCampaign(true);
    setOpenMenu(false);
  };
  const columns = [
    {
      title: "Campaign ID",
      dataIndex: "cid",
      render: (text, record) => (
        <div className="product-copy-text-field">
          <a
            className="campaign-link"
            href={`/buyer/campaigndetails?_id=${btoa(record.id)}`}
          >
            {text}
          </a>
          <CopyOutlined
            onClick={(e) => {
              e.stopPropagation(); // prevent tooltip close
              handleCopy(text);
            }}
            className="copy-icon"
          />
        </div>
      ),
      align: "left", // Center text
      width: `${isMobile ? "22vw" : "13vw"}`,
      key: "cid",
    },
    {
      title: "Campaign Name",
      dataIndex: "name",
      align: "left",
      width: `${isMobile ? "22vw" : "13vw"}`,
      key: "name",
      render: (text, record) => (
        <div className="product-copy-text-field">
          <Text className="card-campaign-text">{record?.name}</Text>
          <CopyOutlined
            onClick={(e) => {
              e.stopPropagation(); // prevent tooltip close
              handleCopy(text);
            }}
            className="copy-icon"
          />
        </div>
      ),
    },
    {
      title: "Paid",
      dataIndex: "paid",
      align: "right",
      width: `${isMobile ? "22vw" : "8vw"}`,
      render: (text, record) =>
        `${formatToUSCurrency(record?.paid?.toFixed(2))}`,
      key: "paid",
    },
    {
      title: "Pending",
      dataIndex: "pending",
      align: "right",
      width: `${isMobile ? "22vw" : "8vw"}`,
      render: (text, record) => getPendingFee(record),
      key: "pending",
    },
    {
      title: (
        <div>
          Total{" "}
          <span className="process-fee-header">(with processing fee)</span>
        </div>
      ),
      dataIndex: "act_budget",
      align: "right",
      width: `${isMobile ? "22vw" : "14vw"}`,
      render: (text, record) =>
        `${formatToUSCurrency(
          (record?.act_budget + record?.processing_fee)?.toFixed(2)
        )}`,
      key: "total",
    },
    {
      title: <div style={{ textAlign: "center" }}>No. of Products</div>,
      dataIndex: "product_count",
      align: "center",
      width: `${isMobile ? "22vw" : "10vw"}`,
      key: "products",
    },
    {
      title: "Date",
      dataIndex: "created_at",
      align: "left",
      width: `${isMobile ? "22vw" : "8vw"}`,
      render: (text, record) => formatDate(record?.updated_at),
      key: "date",
    },
    {
      title: <div style={{ textAlign: "center" }}>Actions</div>,
      dataIndex: "action",
      align: "center", // Centering UI elements too
      width: `${isMobile ? "22vw" : "10vw"}`,
      key: "action",
      render: (text, record) => (
        <div className="ellipse-container">
          <div className="payment-action-items">
            <Popover
              onOpenChange={() => setOpenMenu(false)}
              open={openMenu && recordId == record?.id}
              key={record.id}
              content={() => content(record)}
              trigger="click"
              placement="bottomLeft"
            >
              <Button
                shape="circle"
                className={`payment-ellipsis-btn ${
                  recordId === record.id && openMenu ? "active-ellipsis" : ""
                }`}
                onClick={() => handleOpenMenu(record)}
              >
                <EllipsisOutlined className="rotate-ellipsis-icon" />
              </Button>
            </Popover>
          </div>
        </div>
      ),
    },
  ];

  const filterPayments = () => {};
  const onInputChange = (value) => {
    setSearchPayments(value);
    if (value.trim() == "") setFilteredList(buyerPaymentsList);
  };

  const onPaymentRowClick = (record) => ({
    onClick: (event) => {
      // Find the clicked cell (td)
      const cell = event.target.closest("td");
      if (!cell) return;

      // Find index of cell inside the row
      const cellIndex = Array.from(cell.parentNode.children).indexOf(cell);
      if (cellIndex === -1) return;
      // Get the column key based on the index
      const columnKey = columns[cellIndex]?.key;

      if (columnKey !== "action") {
        goToSubPage(record);
        navigate(`/buyer/campaigndetails?_id=${btoa(record?.id)}`);
      }
    },
  });

  const downloadQuoteInvoice = (record, type) => {
    message.success(
      type == "quote" ? "Quote is downloading..." : "Invoice is downloading..."
    );
    setType(type);
    setCampaignId(record?.id);
    setCampaignCid(record?.cid);
    if (type == "quote") {
      dispatch(downloadQuote(record?.id));
    } else {
      dispatch(downloadInvoice(record?.id));
    }
    setOpenMenu(false);
  };

  const downloadPdf = (type) => {
    const blob =
      type == "quote"
        ? new Blob([quotePdf], {
            type: "application/pdf",
          })
        : new Blob([downloadInvoicePdf], {
            type: "application/pdf",
          });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download =
      type == "quote"
        ? `Quote-${campaignCid}.pdf`
        : `Payments-${campaignCid}.pdf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
    setCampaignId(null);
  };
  // Search results when text typing is paused for 0.4 sec
  useEffect(() => {
    if (!searchDidMountRef.current) {
      searchDidMountRef.current = true;
      return;
    } else {
      if (!searchPayments) {
        dispatch(getBuyerPaymentsList({ value: "payments", currentPage }));
      }
      const delayDebounce = setTimeout(() => {
        if (searchPayments) {
          dispatch(getBuyerPaymentsList({ value: "payments", currentPage }));
        }
      }, 400);
      return () => {
        clearTimeout(delayDebounce);
      };
    }
  }, [searchPayments]);
  // Loading payment data in table
  useEffect(() => {
    dispatch(getBuyerPaymentsList({ value: "payments", currentPage }));
    setFilteredList(
      isDashboard ? buyerPaymentsList?.slice(0, 10) : buyerPaymentsList
    );
  }, [currentPage]);

  useEffect(() => {
    setFilteredList(buyerPaymentsList);
  }, [buyerPaymentsList]);
  // downloading Invoice on api response from  downloadInvoice
  useEffect(() => {
    if (campaignCid && (downloadInvoicePdf || quotePdf)) {
      downloadPdf(type);
    }
  }, [downloadInvoicePdf, quotePdf]);

  return (
    <div className={`${!isDashboard ? "billing-payments-container" : ""}`}>
      {isDashboard ? (
        <Row className="purchases-section">
          <Col
            span={isMobile ? 20 : 22}
            className="campaigns-sub-header recent-purchase"
          >
            {" "}
            Recent Purchase
          </Col>
          {filteredList?.length > 0 && (
            <Col
              span={isMobile ? 4 : 2}
              className="highlight-text see-all pointer"
              onClick={() => {
                goToSubPage1({ title: "Payments", path: "/buyer/payments" });
                navigate("/buyer/payments");
              }}
            >
              {" "}
              See all
            </Col>
          )}
        </Row>
      ) : (
        <>
          <div className="bread-crumb-placement">
            <BreadcrumbNav />
          </div>
          <Row className="billings-header">
            <Col xl={12} md={12} sm={24} className="campaigns-header">
              <Text className="advertisement-txt">Transaction History</Text>
              <span className="single-calendar"></span>
            </Col>
          </Row>
          {!isMobile && (
            <Row className="transaction-header payments-table-content">
              <Col span={24} className="action-inputs">
                <Select
                  className="filter-payments"
                  placeholder="Search Payments"
                  options={[
                    { value: "30", label: "Last 30 days" },
                    { value: "90", label: "Last 3 months" },
                    { value: "180", label: "Last 6 months" },
                  ]}
                  onChange={filterPayments}
                ></Select>
                <Input
                  allowClear
                  prefix={<SearchIcon />}
                  className="search-payments common-search"
                  placeholder="Search your invoice"
                  value={searchPayments}
                  onChange={(event) => onInputChange(event.target.value)}
                />
              </Col>
            </Row>
          )}
        </>
      )}
      {!isMobile && !isDashboard && <Divider />}

      {isPaymentsLoading ? (
        <div className="loading-css">
          <Spin size="large" fullscreen />
        </div>
      ) : (
        <>
          {!isMobile && filteredList ? (
            <>
              <div
                className={`${!isDashboard ? "payments-table-content" : ""}`}
              >
                <div
                  className={`${
                    !isDashboard
                      ? "payments-section"
                      : "dashboard-payments-section"
                  }`}
                >
                  <Table
                    onRow={onPaymentRowClick}
                    className={`${
                      isDashboard
                        ? "partial-payment-table"
                        : "buyer-payments-table"
                    }`}
                    columns={columns}
                    sticky
                    dataSource={filteredList}
                    pagination={isDashboard ? false : true}
                  />
                </div>
              </div>
            </>
          ) : (
            <>
              <Input
                allowClear
                className="search-payments"
                prefix={<SearchIcon />}
                placeholder="Search your invoice"
                value={searchPayments}
                onChange={(event) => onInputChange(event.target.value)}
              />
              {filteredList?.length > 0 ? (
                <>
                  {filteredList?.map((payment) => {
                    return (
                      <Card className="buyer-payment-card" key={payment.id}>
                        <Row gutter={[12, 24]}>
                          <Col span={16}>
                            <div className="payment-id payment-header">
                              {payment.cid}
                            </div>
                            <div className="payment-name">{payment.name}</div>
                          </Col>
                          <Col span={8} style={{ alignSelf: "center" }}>
                            <div className="payment-price">
                              {formatToUSCurrency(
                                payment.act_budget?.toFixed(2)
                              )}
                            </div>
                          </Col>
                          <Col span={16}>
                            <div className="payment-label payment-header">
                              {" "}
                              Starts from{" "}
                            </div>
                            <div className="payment-value">
                              {formatDate(payment.start_date)}{" "}
                              <span>
                                <Image
                                  src={Arrow3}
                                  style={{ width: "22px", margin: "0 11px" }}
                                  preview={false}
                                />{" "}
                              </span>
                              {formatDate(payment.end_date)}{" "}
                            </div>
                          </Col>
                          <Col span={8}>
                            <div className="payment-label payment-header">
                              No. of Products
                            </div>
                            <div className="payment-value">
                              {payment.product_count}
                            </div>
                          </Col>
                          <Col span={24}>
                            <div className="payment-label payment-header">
                              {" "}
                              Purchased Date
                            </div>
                            <div className="payment-value">
                              {formatDate(payment.created_at)}{" "}
                            </div>
                          </Col>
                          <Col className="download-column" span={24}>
                            <a
                              className="dashboard-invoice-download"
                              style={{
                                color: "#d2042d",
                                display: "flex",
                                gap: ".6rem",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                              onClick={() =>
                                downloadQuoteInvoice(payment, "invoice")
                              }
                            >
                              <DownloadDocumentIcon color={"#000"} />
                              Download Invoice
                            </a>
                          </Col>
                        </Row>
                      </Card>
                    );
                  })}
                </>
              ) : (
                <div className="no-records-card">
                  <EmptyViewCard
                    header={"Payments"}
                    text={
                      "It looks like you haven't purchased any campaigns..."
                    }
                  />
                </div>
              )}
            </>
          )}
        </>
      )}

      {shareCampaign && (
        <ShareCampaign
          shareCampaign={shareCampaign}
          setShareCampaign={setShareCampaign}
          campaignId={campaignId}
        />
      )}
    </div>
  );
};

export default Payments;
